import { render, staticRenderFns } from "./syrecord.vue?vue&type=template&id=091af790&scoped=true"
import script from "./syrecord.vue?vue&type=script&lang=js"
export * from "./syrecord.vue?vue&type=script&lang=js"
import style0 from "./syrecord.vue?vue&type=style&index=0&id=091af790&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "091af790",
  null
  
)

export default component.exports